import { styled } from '@mui/material';

export const Preview = styled('div')(() => ({
  display: 'flex',
  height: '100%',
  width: '100%',
  justifyContent: 'center',
  alignItems: 'stretch',
  position: 'relative',
}));

export const PreviewHeaderWrapper = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(2),
  right: theme.spacing(2),
}));

export const PreviewIframe = styled('div', {
  shouldForwardProp: prop => prop !== 'darkmode',
})(({ theme, darkmode, offset }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  margin: '24px',
  ...(offset && {
    marginTop: '80px',
  }),

  '#connect-preview-background': {
    maxWidth: '380px',
    maxHeight: '730px',
    height: '100%',
    position: 'absolute',
    top: '0',
    left: '0',
    backgroundColor: '#FFF',
    borderRadius: '18px',
    ...(darkmode && {
      backgroundColor: '#151D20',
    }),
  },

  '& iframe': {
    width: '380px',
    maxHeight: '730px',
    height: '100%',
    border: theme.border.default,
    borderRadius: '18px',
  },
}));
